import { css } from 'styled-components';

var themeMap = {
  olive: {
    background: css(["var(--color-olive-800)"]),
    text: css(["var(--color-white)"]),
    hover: css(["var(--color-olive-700)"])
  },
  sand: {
    background: css(["var(--color-sand-300)"]),
    text: css(["var(--color-almostblack)"]),
    hover: css(["var(--color-sand-400)"])
  },
  rouge: {
    background: css(["var(--color-rouge-500)"]),
    text: css(["var(--color-white)"]),
    hover: css(["var(--color-rouge-400)"])
  },
  white: {
    background: css(["var(--color-white)"]),
    text: css(["var(--color-almostblack)"]),
    hover: css(["var(--color-white)"])
  },
  'dark-core': {
    background: css(["var(--color-dark-core-500)"]),
    text: css(["var(--color-white)"]),
    hover: '#ff7e33'
  },
  core: {
    name: 'core',
    background: css(["var(--color-core-500)"]),
    text: css(["var(--color-almostblack)"]),
    hover: '#ffa332'
  },
  'almost-black': {
    background: css(["var(--color-almostblack)"]),
    text: css(["var(--color-white)"]),
    hover: '#3a3a3a'
  },
  sunlight: {
    background: css(["var(--color-sunlight-200)"]),
    text: css(["var(--color-almostblack)"]),
    hover: '#fff9c9'
  },
  latte: {
    background: css(["var(--color-latte)"]),
    text: css(["var(--color-white)"]),
    hover: '#b7a48a'
  },
  'steel-blue': {
    background: css(["var(--color-steel-blue)"]),
    text: css(["var(--color-white)"]),
    hover: '#869b9f'
  },
  'dark-steel-blue': {
    background: css(["var(--color-dark-steel-blue)"]),
    text: css(["var(--color-white)"]),
    hover: '#63838a'
  },
  sandstone: {
    background: css(["var(--color-sandstone)"]),
    text: css(["var(--color-white)"]),
    hover: '#8c8077'
  },
  clay: {
    background: css(["var(--color-clay)"]),
    text: css(["var(--color-almostblack)"]),
    hover: '#d7c5b4'
  },
  plant: {
    background: css(["var(--color-plant)"]),
    text: css(["var(--color-white)"]),
    hover: '#738e81'
  }
};

export { themeMap };
//# sourceMappingURL=colorThemes.js.map
